<template>
  <div>
    <div class="form-group">
      <label for="mgm-order-id">Ид заказа в магазине MY.GAMES (опциональное поле)</label>
      <b-icon icon="question-circle" v-b-popover.hover.top="mgmOrderIdDescription" class="ml-1"></b-icon>
      <input v-model="mgmOrderIdInputValue" id="mgm-order-id" class="form-control" >
    </div>

    <div class="form-group">
      <label for="shortSKU">SKU (пример: starter_pack_1)</label>
      <input v-model="shortSKU" id="shortSKU" class="form-control" required>
    </div>
  </div>
</template>

<script>
import { SKU_PREFIX } from '../util.js';

export default {
  name: 'PlayerPendingAddDataInputRestorePaymentBySKU',

  data() {
    return {
      mgmOrderIdInputValue: '',
      shortSKU: '',
    };
  },

  computed: {
    mgmOrderIdDescription() {
      let content = '';
      content += 'Если платеж был сделан через магазин MY.GAMES (т.е. через TopUp или WebView), '
      content += 'то укажие в&nbsp;данном поле идентификатор заказа из личного кабинета. ';
      content += 'В&nbsp;других случаях оставьте данное поле пустым.';

      return {
        html: true,
        content: content,
      };
    },
  },

  methods: {
    fillFormData(formData) {
      const mgmOrderIdStr = this.mgmOrderIdInputValue.trim();
      if(mgmOrderIdStr.length > 0) {
        formData.set('mgm_order_id', mgmOrderIdStr);
      }

      const sku = SKU_PREFIX + this.shortSKU;
      formData.append('sku', sku);

      return null;
    },
  },
}
</script>
